import { CoreModel } from '../core/core.model';
/**
 * <h4>Example of TreeView Model:</h4>
 * <pre>{{'{'}}
 * items: [
 *    {{'{'}}
 *      _id: '1',
 *      _name: 'root1',
 *        _expanded: true,
 *        _children: [
 *        {{'{'}}
 *              _id: '2',
 *              _expanded: false,
 *              _name: 'child1'
 *          {{'}'}},
 *            {{'{'}}
 *              _id: '3',
 *              _expanded: false,
 *              _name: 'child2'
 *            {{'}'}}
 *        ]
 *    {{'}'}}
 *  ],
 * options: {{'{'}}
 *    idField: '_id',
 *    displayField: '_name',
 *    childrenField: '_children',
 *    isExpandedField: '_expanded',
 *    selectable: true,
 *    allowDrag: true,
 *    animateExpand: true
 * {{'}'}}
 * {{'}'}}</pre>
 */
export class TreeviewModel extends CoreModel {
/**
 * Array of tree items
 */
items: any[];
/**
 * Treeview options object
 */
options?: {
    /**
     * Name of property to be ID for the item
     */
    idField?: string;
    /**
     * Name of property to be NAME for the item
     */
    displayField?: string;
    /**
     * Name of property to be ARRAY with childrens for the item
     */
    childrenField?: string;
    /**
     * Name of property to be boolean EXPANDED for the item
     */
    isExpandedField?: string;
    /**
     * Boolean property which means to be selectable with checkbox for each item
     */
    selectable?: boolean;
    /**
     * Boolean property which means to alow items draging
     */
    allowDrag?: boolean;
    /**
     * Boolean property which means animated items expanding
     */
    animateExpand?: boolean;
  }
/**
 * @hidden 
 * It is the constructor for the Treeview component. It takes the values to create the Treeview object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function TreeviewModel_tsickle_Closure_declarations() {
/**
 * Array of tree items
 * @type {?}
 */
TreeviewModel.prototype.items;
/**
 * Treeview options object
 * @type {?}
 */
TreeviewModel.prototype.options;
}

